// @flow
import React from 'react';
import { OutboundLink } from 'gatsby-plugin-google-gtag';

import * as styles from './Footer.module.scss';
import Logo from '../../images/logo-white.svg';
import BadgeAppStore from '../../images/badge-app-store.svg';
import BadgeGooglePlay from '../../images/badge-google-play.svg';
import IconTwitter from '../../images/icon-twitter-white.svg';
import IconLinkedin from '../../images/icon-linkedin.svg';

const Footer = () => {
  const baseUrl = window.location.host;

  return (
    <>
      <div className={styles.footerWrapper}>
        <footer>
          <a href={baseUrl}>
            <img
              className={styles.logo}
              src={Logo}
              alt="Paidy"
              height="40"
              loading="lazy"
              width="77"
            />
          </a>
          <nav>
            <div className={styles.title}>できること</div>
            <a href={`https://${baseUrl}/payments`}>Paidy翌月払いとは</a>
            <a href={`https://${baseUrl}/payments/#flow`}>ご利用方法</a>
            <a href={`https://${baseUrl}/security/`}>安全への取り組み</a>
            <a href={`https://${baseUrl}/payments/#campaign`}>キャンペーン情報</a>
            <OutboundLink
              title="Paidy | ヘルプ"
              className={styles.badge}
              href="https://support.paidy.com/hc/ja"
              target="_blank"
              rel="noopener noreferrer"
            >
              ヘルプ
            </OutboundLink>
            <OutboundLink
              title="Paidy | T&C"
              className={styles.badge}
              href="https://terms.paidy.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              利用規約
            </OutboundLink>
          </nav>
          <nav>
            <div className={styles.title}>使えるお店</div>
            <a href={`https://${baseUrl}/shop/`}>お店紹介</a>
            <a href={`https://${baseUrl}/shop/list/`}>お店一覧</a>
            <a href={`https://${baseUrl}/shop/#editors_pick`}>ピックアップアイテム</a>
            <a href={`https://${baseUrl}/shop/#popular_shops`}>おすすめのお店</a>
          </nav>
          <nav>
            <div className={styles.title}>会社プロフィール</div>
            <a href={`https://${baseUrl}/company/#company_overview`}>会社概要</a>
            <a href={`https://${baseUrl}/company/#teams`}>マネジメントチーム</a>
            <OutboundLink
              href="https://careers.paidy.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              採用情報
            </OutboundLink>
          </nav>
          <div className={styles.vertical}>
            <nav>
              <div className={styles.title}>法人のお客様</div>
              <a href={`https://${baseUrl}/merchant/`}>法人のお客様</a>
              <a href={`https://${baseUrl}/merchant/#case_study`}>導入事例</a>
              <a href={`https://${baseUrl}/merchant/contact_us/`}>法人/PRお問合せ</a>
            </nav>
            <nav>
              <div className={styles.title}>導入について</div>
              <a href={`https://${baseUrl}/merchant/application/#documents`}>導入申込み</a>
              <OutboundLink href="/docs/jp/" rel="noopener noreferrer" target="_blank">
                技術ドキュメント
              </OutboundLink>
              <OutboundLink
                href="https://merchant.paidy.com/login"
                target="_blank"
                rel="noopener noreferrer"
              >
                加盟店ログイン
              </OutboundLink>
            </nav>
          </div>
          <div className={styles.misc}>
            <nav className={styles.app}>
              <OutboundLink
                title="Paidy | App Store"
                className={styles.badge}
                href="https://apps.apple.com/jp/app/paidy/id1220373112"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={BadgeAppStore}
                  alt="Paidy | App Store"
                  width="140"
                  height="42"
                  loading="lazy"
                />
              </OutboundLink>
              <OutboundLink
                title="Paidy | Google Play"
                className={styles.badge}
                href="https://play.google.com/store/apps/details?id=com.paidy.paidy&hl=ja"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={BadgeGooglePlay}
                  alt="Paidy | Google Play"
                  width="140"
                  height="42"
                  loading="lazy"
                />
              </OutboundLink>
            </nav>
            <nav className={styles.sns}>
              <OutboundLink
                className={styles.badge}
                href="https://twitter.com/paidyjp"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={IconTwitter}
                  alt="Paidy | Twitter"
                  width="30"
                  height="24"
                  loading="lazy"
                />
              </OutboundLink>
              <OutboundLink
                className={styles.badge}
                href="https://www.linkedin.com/company/paidy/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={IconLinkedin}
                  alt="Paidy | Linkedin"
                  width="30"
                  height="24"
                  loading="lazy"
                />
              </OutboundLink>
            </nav>
            <small>&copy; Paidy Inc.</small>
          </div>
        </footer>
      </div>
    </>
  );
};

Footer.defaultProps = { isMerchant: false };

export default Footer;
